// Sources of the offers (sites where they are bought) and channels of the
// sales, as shown in the app: the one place to add or rename a site.
// (API side: connectors/ of api.prexens.com.)

// Source of the offers saved before the "source" field existed
export const DEFAULT_SOURCE = "yahoo";

export const SOURCES = {
  yahoo: {
    label: "Yahoo",
    longLabel: "Yahoo! Auctions",
    color: "#ff0033",
    icon: "fas fa-gavel",
    itemUrl: "https://page.auctions.yahoo.co.jp/jp/auction/{id}",
    // Price of an auction read again without photos (API: read_auction_state)
    quickPrice: true,
  },
  ebay: {
    label: "eBay",
    longLabel: "eBay",
    color: "#0064d2",
    icon: "fas fa-shopping-bag",
  },
  vinted: {
    label: "Vinted",
    longLabel: "Vinted",
    color: "#09b1ba",
    icon: "fas fa-tshirt",
  },
  leboncoin: {
    label: "LeBonCoin",
    longLabel: "LeBonCoin",
    color: "#e95c11",
    icon: "fas fa-tag",
  },
  mercari: {
    label: "Mercari",
    longLabel: "Mercari",
    color: "#ff4134",
    icon: "fas fa-store",
    itemUrl: "https://jp.mercari.com/item/{id}",
  },
  manual: {
    label: "Manuel",
    longLabel: "Manuel",
    color: "#6c757d",
    icon: "fas fa-box",
  },
};

// A source of an offer: its display, the default source when missing, the id
// itself for a source unknown here
export const sourceInfo = (id) =>
  SOURCES[id] ||
  (id
    ? { label: id, longLabel: id, color: "#6c757d", icon: "fas fa-tag" }
    : SOURCES[DEFAULT_SOURCE]);
export const sourceLabel = (id) => sourceInfo(id).label;
export const hasQuickPrice = (id) => Boolean(sourceInfo(id).quickPrice);
export const sourceLongLabel = (id) => sourceInfo(id).longLabel;
// Page of an item on its site, when the site has a known address
export const itemUrl = (id, itemId) =>
  SOURCES[id || DEFAULT_SOURCE]?.itemUrl?.replace("{id}", itemId) || null;

// Channels of a sale
export const SALE_CHANNELS = {
  leboncoin: "LeBonCoin",
  vinted: "Vinted",
  ebay: "eBay",
  main_propre: "Main propre",
  other: "Autre",
};
export const saleChannelLabel = (id) => SALE_CHANNELS[id] || "Autre";

// Senders of a package other than the intermediaries (ZenMarket, Buyee:
// listed by the API, their fees are computed)
export const PACKAGE_SENDERS = {
  private: "Particulier",
  shop: "Site marchand",
  other: "Autre",
};
